import React from 'react';

export const PrintableToken = ({ tokenData, onClose }) => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      {/* Screen view - Modal */}
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 no-print" data-testid="print-modal">
        <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full">
          <h2 className="text-2xl font-bold text-slate-900 mb-6 text-center">Token Generated Successfully!</h2>
          
          <div className="border-4 border-slate-900 rounded-lg p-6 mb-6 bg-slate-50">
            <div className="text-center mb-4">
              <div className="text-sm font-medium text-slate-600 mb-2">TOKEN NUMBER</div>
              <div className="font-mono text-6xl font-black text-slate-900 tracking-widest">
                {tokenData.token_number}
              </div>
            </div>
            <div className="border-t-2 border-slate-300 pt-4 mt-4">
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-xs text-slate-500">Gender</div>
                  <div className={`text-lg font-bold ${
                    tokenData.gender === 'Male' ? 'text-indigo-600' : 'text-rose-600'
                  }`}>
                    {tokenData.gender}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-slate-500">Issued At</div>
                  <div className="text-sm font-medium text-slate-700">
                    {new Date(tokenData.created_at).toLocaleTimeString()}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <button
              onClick={handlePrint}
              data-testid="print-token-button"
              className="flex-1 bg-indigo-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition-colors"
            >
              Print Token
            </button>
            <button
              onClick={onClose}
              data-testid="close-print-modal"
              className="flex-1 bg-slate-200 text-slate-700 px-6 py-3 rounded-lg font-semibold hover:bg-slate-300 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>

      {/* Print view */}
      <div className="print-only">
        <div style={{ 
          width: '58mm', 
          fontFamily: 'monospace',
          textAlign: 'center',
          padding: '5mm'
        }}>
          <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '3mm' }}>
            RICHMOND MEDICARE
          </div>
          
          <div style={{ 
            border: '2px solid #000', 
            padding: '5mm', 
            marginBottom: '3mm',
            marginTop: '3mm'
          }}>
            <div style={{ fontSize: '32px', fontWeight: 'bold', letterSpacing: '2px' }}>
              {tokenData.token_number}
            </div>
          </div>

          <div style={{ fontSize: '11px', color: '#666', marginTop: '3mm' }}>
            {new Date(tokenData.created_at).toLocaleString('en-IN', { 
              day: '2-digit', 
              month: '2-digit', 
              year: 'numeric',
              hour: '2-digit', 
              minute: '2-digit',
              hour12: true 
            })}
          </div>
        </div>
      </div>

      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          .no-print, .no-print * {
            display: none !important;
          }
          .print-only, .print-only * {
            visibility: visible;
          }
          .print-only {
            position: absolute;
            left: 0;
            top: 0;
          }
          @page {
            size: 58mm 40mm;
            margin: 2mm;
          }
        }
        @media screen {
          .print-only {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

export default PrintableToken;